import { Box, Button, Stack, Typography } from '@mui/material';
import { Banda, Celda, Rotulo, ALTURA_TACTIL } from 'src/components/ui/casa';

// Al terminar el recorrido: dos caminos con Control de Obra. Tocar uno manda su título al chat, que sigue desde ahí.
export default function ProximosPasos({ opciones, onElegir }) {
  if (!Array.isArray(opciones) || opciones.length === 0) return null;
  return (
    <Box sx={{ mt: 1, width: '100%', minWidth: { sm: 360 } }}>
      <Rotulo sx={{ mb: 0.75 }}>¿Y ahora qué?</Rotulo>
      <Banda columnas={1}>
        {opciones.map((opcion) => (
          <Celda key={opcion.clave}>
            <Stack spacing={0.5}>
              <Typography sx={{ fontSize: 14, fontWeight: 700 }}>{opcion.titulo}</Typography>
              <Typography variant="body2" color="text.secondary">
                {opcion.porque}
              </Typography>
              <Box>
                <Button variant="outlined" onClick={() => onElegir(opcion)} sx={{ minHeight: ALTURA_TACTIL, textTransform: 'none', mt: 0.5 }}>
                  Empezar
                </Button>
              </Box>
            </Stack>
          </Celda>
        ))}
      </Banda>
    </Box>
  );
}
